import type { IDocument, IJobSiteInfo } from '@/interfaces'
import DocumentModel from './DocumentModel'

class JobSiteInfo implements IJobSiteInfo {
  isTankCleaned: boolean
  isTankDisinfected: boolean
  time: string | undefined
  weighTicketNumber: string | null
  quantityInMetricTonne: number
  documents: IDocument[]
  signature: IDocument | null
  isOperatorPresent: boolean

  constructor(details?: IJobSiteInfo) {
    this.isTankCleaned = details?.isTankCleaned ?? false
    this.isTankDisinfected = details?.isTankDisinfected ?? false
    this.time = details?.time
    this.weighTicketNumber = details?.weighTicketNumber ?? null
    this.quantityInMetricTonne = details?.quantityInMetricTonne ?? 0
    this.documents = details?.documents?.map((document: any) => new DocumentModel(document)) ?? []
    this.signature = details?.signature ? new DocumentModel(details?.signature) : null
    this.isOperatorPresent = details?.isOperatorPresent ?? false
  }
}

export default JobSiteInfo
